module.exports = {
  T0: 'Fiber Guide',
  T1: 'Polymer Nozzle',
  B: 'Bed',
  C: 'Build Chamber',
  M: 'Material Chamber',
  IR: 'Rollforming'
};
